"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorUpdateShouldTargetChild = exports.markUnderCursorForType = exports.hasSelection = exports.selectionDirection = exports.allMarksInSelectionForTypeName = exports.allMarksForSelectionTextNodes = void 0;
const lodash_1 = require("lodash");
/**
 * Get all the text nodes that are part of the current selection and their marks
 */
function allMarksForSelectionTextNodes(editor) {
    if (!editor || !editor.state.selection)
        return [];
    const { from, to } = editor.state.selection;
    const marks = [];
    editor.view.state.doc.nodesBetween(from, to, (node) => {
        if (node.type.name === 'text') {
            marks.push(node.marks);
        }
    });
    return marks;
}
exports.allMarksForSelectionTextNodes = allMarksForSelectionTextNodes;
/**
 * Get all marks of a certain type that are part of the current selection
 */
function allMarksInSelectionForTypeName(editor, typeName) {
    const nodeMarks = allMarksForSelectionTextNodes(editor);
    return nodeMarks.map((marks) => marks.find((mark) => mark.type.name === typeName));
}
exports.allMarksInSelectionForTypeName = allMarksInSelectionForTypeName;
/**
 * Are we selecting from left to right or right to left
 */
function selectionDirection(editor) {
    if (!editor)
        return 'forward';
    const { $anchor, $head } = editor.state.selection;
    return $anchor.pos < $head.pos ? 'forward' : 'backward';
}
exports.selectionDirection = selectionDirection;
function hasSelection(editor) {
    return editor?.state.selection.from !== editor?.state.selection.to;
}
exports.hasSelection = hasSelection;
/**
   Gets the mark that is currently under the mouse cursor when selecting text.
   This is needed because `editor.getAttributes` does not return undefined if there is no mark
   for the current node in the selection, but the last known mark value.
  */
function markUnderCursorForType(editor, typeName) {
    const marks = allMarksInSelectionForTypeName(editor, typeName);
    const direction = selectionDirection(editor);
    if (direction === 'forward') {
        return (0, lodash_1.last)(marks);
    }
    else {
        return (0, lodash_1.first)(marks);
    }
}
exports.markUnderCursorForType = markUnderCursorForType;
/**
 * Decide if the update should target the whole component or just the current focused element(s)
 */
const editorUpdateShouldTargetChild = (editor, isDetailMode) => {
    if (!editor)
        return false;
    if (isEmpty(editor) || isSelectAll(editor))
        return false;
    if (hasSelection(editor))
        return true;
    return !!isDetailMode;
};
exports.editorUpdateShouldTargetChild = editorUpdateShouldTargetChild;
/**
 * Detect if we selected all the text in the editor
 * Because we can than treat it as a component level update
 */
const isSelectAll = (editor) => {
    const state = editor.state;
    const totalLength = state.doc.content.size;
    const selection = state.selection;
    if (selection && totalLength) {
        const { from, to } = selection;
        const text = state.doc.textBetween(from, to, blockSeparator);
        const allText = editor.getText({ blockSeparator });
        return text === allText;
    }
    return false;
};
// if you want to be able to compare, use the same blockSeparator
const blockSeparator = ' ';
const isEmpty = (editor) => editor.isEmpty;
//# sourceMappingURL=editor-utils.js.map